import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  cn,
} from '@parcel/ui';
import { IMPACT_LABEL, SCORE_IMPACTS, type ScoreImpact } from './criteria-state.js';

const WEIGHTED = SCORE_IMPACTS.filter((impact) => impact !== 'disqualify');

export function ImpactSelect({
  value,
  disabled,
  onChange,
}: {
  value: ScoreImpact;
  disabled?: boolean;
  onChange: (impact: ScoreImpact) => void;
}) {
  return (
    <Select
      value={value}
      onValueChange={(next) => onChange(next as ScoreImpact)}
      disabled={disabled}
    >
      <SelectTrigger
        size="sm"
        aria-label="Impact"
        className={cn('w-48 px-2.5', value === 'disqualify' && 'text-destructive')}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {WEIGHTED.map((impact) => (
          <SelectItem key={impact} value={impact}>
            {IMPACT_LABEL[impact]}
          </SelectItem>
        ))}
        <SelectSeparator />
        <SelectItem value="disqualify" className="text-destructive focus:text-destructive">
          {IMPACT_LABEL.disqualify}
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
